/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import React, { Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REQUIREMENTSTRUCTURE_API_BASE } from '../../../../api/api';
import { useGenericAPI } from '../../../../api/useGenericApi';
import { ProTable } from '../../../../atoms/Table/Table';
import { ApplicationElementType, getBaseBCItemForType } from '../../../../components/DetailWindow/breadCrump.helpers';
import { ProPage } from '../../../../components/Page/Page';
import { ProjectContext } from '../../../../contexts/ProjectContext';
import { UserContext } from '../../../../contexts/UserContext';
import { useWBSDetailWindow } from '../../../../modules/Windows/WBSElement/WBSElementHook/WBSDetailFrame';
import { Components } from '../../../../utils/types';
import { RequirementContextProvider } from '../../Requirements/context/RequirementContext';
import {
    RequirementDetailWindowType,
    useRequirementDetailsFrame,
} from '../../Requirements/modules/RequirementDetailsFrame';
import { getReviewSprintTableData } from './Review.helpers';

export const SprintReviewPage = ({
    setSelectedSprint,
    selectedSprint,
}: {
    selectedSprint: Components.Schemas.WBSElementDeltaDTO;
    setSelectedSprint: Dispatch<SetStateAction<Components.Schemas.WBSElementDeltaDTO | undefined>>;
}) => {
    const { t } = useTranslation();
    const { selectedProject, loading: projectLoading, error: projectError, selectedTeam } = useContext(ProjectContext);
    const [selectedRequirement, setSelectedRequirement] = useState<Components.Schemas.RequirementDTO>();
    const [selectedTableRow, setSelectedTableRow] = useState<number>();

    const { portfolio } = useContext(UserContext);

    // const { data: sprint } = useWBSElement(selectedSprint.id);

    const deselectTableRow = () => {
        setSelectedTableRow(undefined);
        setSelectedRequirement(undefined);
        open('hidden');
        openWBS('hidden', false);
    };

    const selectSprint = () => {
        setSelectedTableRow(0);
        setSelectedRequirement(undefined);
        open('hidden');
        openWBS('view');
    };

    const syncWBSScructure = () => {};

    const {
        open: openWBS,
        renderWBSDetailWindow,
        isDisplayed: wbsIsDisplayed,
        mode: detailWindowMode,
        data: sprint,
        sync: syncWBS,
    } = useWBSDetailWindow('Sprint', deselectTableRow, selectedSprint, syncWBSScructure);

    const selectedRequStruct = useMemo(
        () => selectedProject?.requirementStructures?.find((cur) => cur.version === 'Forecast'),
        [selectedProject]
    );

    const selectElement = (id?: string) => {
        const req = requirementStructure?.requirements?.find((cur) => cur.id === id);
        if (req) {
            setSelectedTableRow(1);
            open('view');
            openWBS('hidden', false);
            setSelectedRequirement(req);
        }
    };

    // Todo: get current sprint from selected sprint dynamic

    const {
        data: requirementStructure,
        error,
        loading,
        sync,
    } = useGenericAPI<Components.Schemas.RequirementStructureDTO>(
        `${REQUIREMENTSTRUCTURE_API_BASE}/${selectedRequStruct?.id}/Team`,
        selectedTeam?.id
    );

    const { isDisplayed, mode, open, renderDetailWindow } = useRequirementDetailsFrame({
        closeAction: deselectTableRow,
        id: selectedRequirement?.id,
        selectAction: selectElement,
        externalSync: async () => {
            syncWBS();
            return sync();
        },
        type: RequirementDetailWindowType.Review,
    });

    const sprintTableData = useMemo(
        () =>
            getReviewSprintTableData({
                selectElement,
                t,
                selectedSprint: sprint,
                selectSprint,
                wbsIsDisplayed,
                sync,
                portfolio,
                setSelectedTableRow,
            }),
        [isDisplayed, mode, selectElement, t]
    );

    return (
        <ProPage
            breadCrump={getBaseBCItemForType(
                [
                    ApplicationElementType.TeamManagement,
                    { type: ApplicationElementType.TeamManagement, name: selectedTeam?.name },
                ],
                t
            )}
            name={'Sprint review / Acceptance'}
            loading={loading}
        >
            <RequirementContextProvider>
                {selectedProject && (
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <ProTable
                            data={sprintTableData}
                            rowsCount={(selectedSprint.requirements?.length || 0) + 1}
                            selectedTableRow={selectedTableRow}
                            getRowClass={(i) => (i === 0 ? `ProTable--row__level-0` : `ProTable--row__level-1`)}
                        />
                    </div>
                )}
                <div
                    className={classNames(
                        'ProApp--detailWindowSection',
                        (isDisplayed || wbsIsDisplayed) && 'ProApp--detailWindowSection__expanded'
                    )}
                >
                    {renderDetailWindow()}
                    {renderWBSDetailWindow()}
                </div>
            </RequirementContextProvider>
        </ProPage>
    );
};
